import React from "react";
import { Link } from "react-router-dom";
import avatardefaultsvg from "../../../assets/images/avatar-default.svg";
import avatar1png from "../../../assets/images/avatar-1.png";
import product2smpng from "../../../assets/images/product-2-sm.png";
import bgheader5png from "../../../assets/images/bg-header-5.png";

function Account(props) {
  return (
    <>
      <header class="dx-header dx-box-5">
        <div class="container">
          <div class="bg-image bg-image-parallax">
            <img src={bgheader5png} class="jarallax-img" alt="" />
            <div style={{ backgroundColor: "rgba(27, 27, 27, 0.8)" }}></div>
          </div>
          <div class="container mnb-8">
            <h1 class="h4 mb-10 text-white text-center">Account</h1>

            <ul class="dx-breadcrumbs text-center">
              <li>
                <Link to="/index">Home</Link>
              </li>
              <li>Account</li>
            </ul>
          </div>
        </div>
      </header>
      <div className="dx-box-5 bg-grey-6">
        <div className="container">
          <div className="row align-items-center justify-content-between vertical-gap mnt-30 sm-gap mb-50">
            <div className="col-auto">
              <h2 className="h4 mb-0 mt-0">Your Tickets</h2>
            </div>
            <div className="col pl-30 pr-30 d-none d-sm-block">
              <div className="dx-separator ml-10 mr-10"></div>
            </div>
            <div className="col-auto">
              <Link to="/ticket-submit" className="dx-btn dx-btn-md">
                Submit a ticket
              </Link>
            </div>
          </div>
          <Link
            to="/single-ticket"
            className="dx-ticket-item dx-ticket-new dx-ticket-open dx-block-decorated"
          >
            <span className="dx-ticket-img">
              <img src={avatar1png} alt="" />
            </span>
            <span className="dx-ticket-cont">
              <span className="dx-ticket-name"> John Leonard </span>
              <span className="dx-ticket-title h5">
                {" "}
                Need help with customization. Some options are not appearing...{" "}
              </span>
              <ul className="dx-ticket-info">
                <li>Update: 5 Nov 2018</li>
                <li>Product: Quantial</li>
                <li>Comments: 2</li>
                <li className="dx-ticket-new">New</li>
              </ul>
            </span>
            <span className="dx-ticket-status"> Open </span>
          </Link>
          <Link
            to="/single-ticket"
            className="dx-ticket-item dx-ticket-closed dx-block-decorated"
          >
            <span className="dx-ticket-img">
              <img src={avatardefaultsvg} alt="" />
            </span>
            <span className="dx-ticket-cont">
              <span className="dx-ticket-name"> Bruno Rice </span>
              <span className="dx-ticket-title h5">
                {" "}
                Theme not updating in downloads{" "}
              </span>
              <ul className="dx-ticket-info">
                <li>Update: 4 Nov 2018</li>
                <li>Product: Sensific</li>
                <li>Comments: 11</li>
              </ul>
            </span>
            <span className="dx-ticket-status"> Closed </span>
          </Link>
        </div>
      </div>
      <div className="dx-separator"></div>
      <div className="dx-box-5 pb-100">
        <div className="container mt-4 mnb-7">
          <div className="row align-items-center justify-content-between vertical-gap mnt-30 sm-gap mb-50">
            <h2 className="col-auto h4 mb-0 mt-0">Purchased Items</h2>
            <div className="col pl-30 pr-30 d-none d-sm-block">
              <div className="dx-separator ml-10 mr-10"></div>
            </div>
            <div className="col-auto">
              <Link to="/account-licenses" className="dx-btn dx-btn-md">
                View Licenses
              </Link>
            </div>
          </div>
          <div className="row vertical-gap">
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/product"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product2smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Quantial – Moving Upon Signs Moveth Lesser
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/product"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product2smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Sensific – Saying Beast Lesser for in Fruitful
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/product"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product2smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Minist – Subdue Above for Signs Dry is Have Great
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/product"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product2smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Desty – She&#39;d Under Light Over Multiply Stars Winged
                </span>
              </Link>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Link
                to="/product"
                className="dx-portfolio-item dx-portfolio-item-style-2 dx-block-decorated"
              >
                <span className="dx-portfolio-item-img">
                  <img src={product2smpng} alt="" />
                </span>
                <span className="dx-portfolio-item-title">
                  Silies – Grass Living Fly Subdue After Fruitful
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Account;
